import { Controller } from "@hotwired/stimulus";

export default class AccordionController extends Controller {
  static targets = ["panel", "icon"];

  toggle(event) {
    const isOpen = this.element.toggleAttribute("data-open");
    this.panelTargets.forEach((el) => el.classList.toggle("hidden", !isOpen));
    this.iconTargets.forEach((el) => el.classList.toggle("rotate-90", isOpen));
    if (event?.currentTarget) {
      event.currentTarget.setAttribute("aria-expanded", isOpen.toString());
    }
  }
}
